import Model from '@app/Model'
import { ModelCategory } from '../../Model'
import { Manufacturer } from '../../Manufacturer'
import { Modification } from '../../Modification'

export class TpParameters extends Model {
	static fields () {
		return {
			id: null,
			model: ModelCategory,
			manufacturer: Manufacturer,
			modification: Modification,
			engine: {
				id: null,
				name: null
			},
			color: null,
			bodyType: null,
			driveType: null,
			gearType: null,
			steeringType: null,
			fuelType: null,
			fuelSystem: null,
			coolingType: null,
			engineDisplacement: null,
			year: null,
			mileage: null,
			vinCode: null,
			mileageType: null,
			platformType: null,
			axleConfiguration: null,
			frontSuspensionType: null,
			rearSuspensionType: null
		}
	}
}
export function createTpParameters (data) {
	return Object.freeze(new TpParameters(data))
}
